module.exports = __webpack_public_path__ + "img/produkt-cibule-cervena.db1830a5.jpg";